var __pow = Math.pow;

export {
  __pow
};
//# sourceMappingURL=chunk-R5Q6Z3GN.mjs.map